import { render, staticRenderFns } from "./BreadCrumbSeparator.vue?vue&type=template&id=3f3127cc&scoped=true&"
import script from "./BreadCrumbSeparator.vue?vue&type=script&lang=js&"
export * from "./BreadCrumbSeparator.vue?vue&type=script&lang=js&"
import style0 from "./BreadCrumbSeparator.vue?vue&type=style&index=0&id=3f3127cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3127cc",
  null
  
)

export default component.exports